'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const waitUntil=require('../../../../dist-es6/testUtils/waitUntil');
const moment=require('pulsar-utils/dist-es6/time/moment');
const IncidentViewModel=require('../../../../dist-es6/client/viewModels/incidentViewModel');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const StatisticsPanelHelpers=require('../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const Formatters=require('../../../../dist-es6/client/formatters');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');
const ErrorMessages=require('../../../../dist-es6/client/errorMessages');

const MaxReportDurationInDays=28;

const NumSVGsPerRasterSchedule=8;
const NumGroupsPerRasterScheduleSVG=16;

const NumSVGsPerTimelineSchedule=1;
const NumGroupsPerTimelineScheduleSVG=21;

const NumSVGsPerDaysSinceLastIncident=1;
const NumGroupsPerDaysSinceLastIncident=4;

const NumSVGsPerTotalIncidents=1;
const NumGroupsPerTotalIncidents=4;

const NumSVGsPerThresholdStatusDonut=1;
const NumGroupsPerThresholdStatusDonut=1;

const NumSVGsPerSparkline=1;
const NumGroupsPerSparkline=5;

const{MinimumStatisticsPanelDimensions}=StatisticsPanelHelpers;let

FatigueReportController=(_class=class FatigueReportController extends BaseController{
constructor(
$scope,
$state,
$timeout,
personalScheduleDataService,
personalIncidentsService,
intervalService,
breadcrumbsService,
socketService,
displaySettingsService,
paramSyncService,
uncaughtErrorHandler,
notificationService,
fatigueMeterTypeContentProviderService){

super(uncaughtErrorHandler,$timeout);

this._assignParamsToController($state.params);

this._updateUrlParamsFromController=paramSyncService.start(this,$scope,newParams=>this._updateControllerParamsFromUrl(newParams));

this._$state=$state;

this.weekFormatter=this.weekFormatter.bind(this);
this.groupFormatter=this.groupFormatter.bind(this);

this._personalScheduleDataService=personalScheduleDataService;
this._personalIncidentsService=personalIncidentsService;
this._intervalService=intervalService;
this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this._fatigueThreshold=null;
this._deviationThreshold=null;
this.isInitiallyLoading=!0;
this._isAwaitingReload=!0;
this._pdfBase64Data=null;
this._socketService=socketService;
this._notificationService=notificationService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

breadcrumbsService.dropCrumb('Fatigue Report');

this._loadScheduleData();
}

_formatIncidentTrendsDataForGraphs(incidents,dayOfLastPurgedIncident,scheduleBoundsStart){
const validIncidentInterval=this._intervalService.getMonthlyLookbackIntervalIncludingCurrentDayFor(this.homeTimezone,StatisticsPanelHelpers.TotalMonthsToDisplayInGraph);

const{
filteredIncidents,
finalIncidentBeforeInterval}=
StatisticsPanelHelpers.filterSortedIncidentsToIntervalPlusOneBefore(incidents,validIncidentInterval);

const daysSinceLastIncidentPathStartTime=StatisticsPanelHelpers.getPathStartTimeForDaysSinceGraph(
_.get(finalIncidentBeforeInterval,'time'),
_.exists(dayOfLastPurgedIncident)?dayOfLastPurgedIncident.startOfDayInTimezone(this.homeTimezone):null,
scheduleBoundsStart,
this.personInfo.creationTime);

const incidentViewModels=filteredIncidents.map(i=>IncidentViewModel.createFrom(i,{code:i.code,description:i.description},this.timezone,_.noop));
for(const ivm of incidentViewModels){
ivm.currentlyScopedGroupMemberships=this.groupMemberships;
}

return{
incidents:incidentViewModels,
incidentInterval:validIncidentInterval,
daysSinceLastIncidentPathStartTime:daysSinceLastIncidentPathStartTime,
panelDimensions:MinimumStatisticsPanelDimensions};

}

_updateControllerParamsFromPersonInfo(personInfo){
this._personId=personInfo.id;
this._employeeId=personInfo.employeeId;
this._updateUrlParamsFromController({
id:this._personId,
employeeId:this._employeeId});

}


async _loadScheduleData(){
if(!_.exists(this._queryInterval)||!(this._queryInterval instanceof TimeInterval)||!_.exists(this._timezone)){
this._$state.go(this._fatigueMeterTypeContentProviderService.defaultFeature);
return;
}

if(Math.floor(this._queryInterval.duration.totalDays())>MaxReportDurationInDays){
this._notificationService.displayNotification(`Reports are currently limited to a maximum of ${MaxReportDurationInDays} days. If this is a problem, please contact support.`,'warning');
this._$state.go(this._fatigueMeterTypeContentProviderService.defaultFeature);
return;
}

let response=await this._personalScheduleDataService.tryGetPersonInfoAndWeeksInQueryInterval(
{id:this._personId,employeeId:this._employeeId},
this._queryInterval,
this._timezone);

if(!_.exists(response)||_.get(response,'error')==='NotFound'){
this._$state.go(this._fatigueMeterTypeContentProviderService.defaultFeature);
return;
}

if(!_.isEqual(response.personInfo,this._personInfo)){
this._updateControllerParamsFromPersonInfo(response.personInfo);
}

this._personInfo=response.personInfo;
const reportWeeks=response.weeksInQueryInterval;

this._isAwaitingReload=!0;
this._pdfBase64Data=null;
this._triggerDigest();

let[{
weekSectionModels,
now,
timeOfLastScheduleUpdate,
timeOfLastHosStatus,
invalidDataWarning,
predictedWorkday,
forecastDutyInterval,
estimatesAsOfTime,
fatigueThreshold,
deviationThreshold,
groupMemberships,
displayTimeZone,
dailyEffectiveStatuses},
{
incidents:incidentsForTrends,
incidentTypes,
dayOfLastPurgedIncident}]=
await Promise.all([
this._personalScheduleDataService.getScheduleDataFor(this._personInfo,reportWeeks,this._timezone),
this._personalIncidentsService.getAllIncidentsFor(this._personId)]);


let reportInterval=TimeInterval.from(reportWeeks[0].start).to(reportWeeks[reportWeeks.length-1].end);

this._estimatesAsOfTime=estimatesAsOfTime;
this._weekSectionModels=weekSectionModels;
this._reportIntervalLabel=this.weekFormatter(reportInterval);
this._now=now;
this._timeOfLastScheduleUpdate=timeOfLastScheduleUpdate;
this._timeOfLastHosStatus=timeOfLastHosStatus;
this._invalidDataWarning=invalidDataWarning;
this._predictedWorkday=predictedWorkday;
this._forecastDutyInterval=forecastDutyInterval;
this._fatigueThreshold=fatigueThreshold;
this._deviationThreshold=deviationThreshold;
this._groupMemberships=groupMemberships;
this._displayTimeZone=displayTimeZone;
this._incidentTrendsData=this._formatIncidentTrendsDataForGraphs(incidentsForTrends,dayOfLastPurgedIncident,_.get(weekSectionModels,'0.personalSchedule.bounds.start'));
this._incidents=this._incidentTrendsData.incidents.map(i=>_.clone(i)).reverse();
this._personalScheduleDataService.attachThresholdStatusesDevationAndTimezoneToIncidents(this._incidents,fatigueThreshold,deviationThreshold,this._timezone,groupMemberships);
for(const _ref of weekSectionModels){const{personalSchedule,dailySchedules}=_ref;
this._personalScheduleDataService.attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold,this._timezone);
}
this._incidentTypes=incidentTypes;

this._isAwaitingReload=!1;
this.isInitiallyLoading=!1;

this._triggerDigest();

await waitUntil(()=>{
const rasterWeeks=angular.element('pulsar-report-raster-schedule');
const timelineWeeks=angular.element('pulsar-report-timeline-schedule');
const daysSinceLastIncident=angular.element('pulsar-days-since-last-incident-graph-panel');
const totalIncidents=angular.element('pulsar-total-incidents-graph-panel');
const thresholdStatusDonut=angular.element('pulsar-threshold-status-donut');
const sparklines=angular.element('pulsar-sparkline');

return rasterWeeks.length===reportWeeks.length&&
timelineWeeks.length===reportWeeks.length&&
_hasRenderedSchedules(rasterWeeks,NumSVGsPerRasterSchedule,NumGroupsPerRasterScheduleSVG)&&
_hasRenderedSchedules(timelineWeeks,NumSVGsPerTimelineSchedule,NumGroupsPerTimelineScheduleSVG)&&(
!this.includeIncidentsPage||
daysSinceLastIncident.length===1&&
totalIncidents.length===1&&
thresholdStatusDonut.length===1&&
sparklines.length===this._incidents.length&&
_hasRenderedSchedules(daysSinceLastIncident,NumSVGsPerDaysSinceLastIncident,NumGroupsPerDaysSinceLastIncident)&&
_hasRenderedSchedules(totalIncidents,NumSVGsPerTotalIncidents,NumGroupsPerTotalIncidents)&&
_hasRenderedSchedules(thresholdStatusDonut,NumSVGsPerThresholdStatusDonut,NumGroupsPerThresholdStatusDonut)&&
_hasRenderedSchedules(sparklines,NumSVGsPerSparkline,NumGroupsPerSparkline));
},2000);

await this._createFatigueReport();
}


async _createFatigueReport(){
const{
displayTimeZone,
fatigueThreshold,
deviationThreshold,
reportIntervalLabel,
timezoneDescription,
timeOfLastHosStatus,
timezone,
personInfo}=
this;

const{firstName,lastName,employeeId}=personInfo;

const reportFooterTimeFormatter=this._use24HourTimeline?
Formatters.timeAndFullDateInTimeZone_24Hour:
Formatters.timeAndFullDateInTimeZone;

const statusUpdateTime=tryGet(timeOfLastHosStatus).
then(t=>reportFooterTimeFormatter(t,timezone)).
otherwise(void 0);

const estimatesAsOfTime=tryGet(this,'estimatesAsOfTime').
then(t=>reportFooterTimeFormatter(t,timezone)).
otherwise(void 0);

await _forImagesToLoad();

const createPdfRequest={
personInfo:{firstName,lastName,employeeId},
formattedGroups:_.compact(this.groupMemberships.map(g=>this.groupFormatter(g))),
reportIntervalLabel,
fatigueThreshold,
deviationThreshold,
displayTimeZone,
timezoneDescription,
statusUpdateTime,
estimatesAsOfTime,
reportSection:angular.element('#report-section').html().replace(/[\r\n\t]+/g,'')};


const response=await this._socketService.sendAndWaitForResponse('GenerateFatigueReport',createPdfRequest);
if(!SocketResponse.succeeded(response)){
this.isErrored=!0;
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
this._triggerDigest();
return;
}

this._pdfBase64Data=response.body;
this._triggerDigest();
}

get includeIncidentsPage(){
return _.get(this._incidentTypes,'length',0)>0;
}

_assignParamsToController(params){
this._personId=params.id;
this._employeeId=params.employeeId;
this._queryInterval=params.interval;
this._timezone=params.timezone;
}

_updateControllerParamsFromUrl(newStateParams){
const{id,interval,timezone,employeeId}=newStateParams;

if(this._personId===id&&
this._employeeId===employeeId&&
this._queryInterval.equals(interval)&&
this._timezone===timezone){
return;
}

this._assignParamsToController(newStateParams);
this._loadScheduleData();
}

_safeThresholdStatusGetter(propertyName){
let fatigue=_.get(this,`personalStatistics.${propertyName}`);

return this._personalScheduleDataService.getThresholdStatus(fatigue,this.fatigueThreshold);
}

get pdfAsBase64(){
return this._pdfBase64Data;
}

get reportIntervalLabel(){
return this._reportIntervalLabel;
}

get timezoneDescription(){
return this.homeTimezone===this.timezone?_.get(this,'_personInfo.initialLocation.description'):this.timezone;
}

get homeTimezone(){
return _.get(this,'_personInfo.homeTimezone');
}

get timezone(){
return this._timezone;
}

get displayTimeZone(){
return this._displayTimeZone;
}

groupFormatter(group){
return _.get(group,'name');
}

get personInfo(){
return this._personInfo;
}

get estimatesAsOfTime(){
return this._estimatesAsOfTime;
}

get fatigueThreshold(){
return this._fatigueThreshold;
}

get deviationThreshold(){
return this._deviationThreshold;
}

get incidents(){
return this._incidents;
}

get incidentTrendsData(){
return this._incidentTrendsData;
}

get notificationType(){
return this._fatigueMeterTypeContentProviderService.visualNotificationType;
}

get groupMemberships(){
return this._groupMemberships;
}

get now(){
return this._now;
}

get timeOfLastScheduleUpdate(){
return this._timeOfLastScheduleUpdate;
}

get timeOfLastHosStatus(){
return this._timeOfLastHosStatus;
}

get invalidDataWarning(){
return this._invalidDataWarning;
}

get predictedWorkday(){
return this._predictedWorkday;
}

get forecastDutyInterval(){
return this._forecastDutyInterval;
}

get peakThresholdStatus(){
return this._safeThresholdStatusGetter('maxFatigueOnDuty');
}

get averageThresholdStatus(){
return this._safeThresholdStatusGetter('averageFatigueOnDuty');
}

get weekSectionModels(){
return this._weekSectionModels;
}

get showLoadingSpinner(){
return!this.isErrored&&(this.isInitiallyLoading||this._isAwaitingReload||!_.exists(this._pdfBase64Data));
}

weekFormatter(weekInterval){
let weekStartString=moment(weekInterval.start).tz(this.timezone).format('MMM DD');
let weekEndString=moment(weekInterval.end-1).tz(this.timezone).format('MMM DD, YYYY');

return`${weekStartString} – ${weekEndString}`;
}

get sleepFormatter(){
if(!_.exists(this._sleepFormatter)){
this._sleepFormatter=interval=>Formatters.timeSpanAsHoursAndMinutes(interval.duration,{colonless:!0});
}
return this._sleepFormatter;
}},(_applyDecoratedDescriptor(_class.prototype,'_loadScheduleData',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_loadScheduleData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_createFatigueReport',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_createFatigueReport'),_class.prototype)),_class);


function _forImagesToLoad(){
return new Promise((resolve,reject)=>$('body').imagesLoaded(()=>resolve()));
}

function _hasRenderedSchedules(parentDirectiveElements,numExpectedSvgsPerDirective,numExpectedGroupsPerSvg){
for(let i=0;i<parentDirectiveElements.length;i++){
let svgs=angular.element(parentDirectiveElements[i]).find('svg');
if(!_.exists(svgs)||svgs.length<numExpectedSvgsPerDirective){
return!1;
}

for(let j=0;j<svgs.length;j++){
const svg=angular.element(svgs[j]);
const groups=svg.find('> g');
if(!_.exists(groups)){
return!1;
}

if(svg.parent().parent().parent().prop('tagName')==='PULSAR-TIMELINE-GRAPH'){
let clipPathRects=svg.find('clipPath > rect');
if(clipPathRects.length>0){
if(!Array.from(clipPathRects).map(rect=>angular.element(rect).attr('height')).
every(h=>h>0)){
return!1;
}
}
}

if(svg.parent().prop('tagName')==='PULSAR-TWENTY-FOUR-HOUR-AXIS-LABEL'&&groups.length===1){
continue;
}

if(groups.length<numExpectedGroupsPerSvg){
return!1;
}
}
}

return!0;
}

module.exports=FatigueReportController;
//# sourceMappingURL=fatigueReportController.js.map
